import PDS_EGTB from "@/content/pdf/Product-Disclosure-Sheet_EGTB_EN.pdf";

export default  {
  "review": {
    "summary.final.insurance": "Total Premium",
    "summary.final.takaful": "Total Contribution",
    "summary.view": "View Summary",
    "summary.hide": "Hide Summary",
    "summary.save": "You save ",
    "summary.title": "Summary",
    "summary.breakdown": "Cost Breakdown",
    "summary.coveragePeriod": "Coverage Period",
    "summary.gross.takaful": "Gross Contribution",
    "summary.gross.insurance": "Gross Premium",
    "summary.discount": "Discount {{rate}} %",
    "summary.serviceTax": "Service Tax",
    "summary.stampDutyAmount": "Stamp Duty",
    "declaration.takaful.title": "Declaration & Aqad",
    "declaration.insurance.title": "Declaration",
    "declaration.subtitle": "You are required to carefully read and tick the following declaration to complete your application:",
    "declaration.confirmation": "I hereby confirm that I have read, and agree to the",
    "declaration.productDisclosureSheet.label": "Product Disclosure Sheet.",
    "declaration.insurance.label": "Declaration",
    "declaration.takaful.label": "Declaration and Aqad",
    "declaration.takaful.policyContract": "Certificate Contract",
    "declaration.insurance.policyContract": "Policy Contract",
    "declaration.importantNotice.label": "Important Notice",
    "declaration.privacyNotice.label": "Privacy Notice",
    "declaration.and": "and",
    "declaration.productDisclosureSheet.egib.link": "https://eti.qa/go/oto360-pds-en",
    "declaration.productDisclosureSheet.egtb.link": PDS_EGTB,
    "declaration.policyContract.egib.link": "https://eti.qa/go/oto360-policy",
    "declaration.policyContract.egtb.link": "https://eti.qa/go/oto360-certificate",
    "declaration.takaful.protectedByPIDM": "The benefit(s) payable under eligible certificate are protected by PIDM up to limits. Please refer to <a className='a-link' href='https://www.pidm.gov.my/en/how-we-protect-you/tips/information-materials/brochures' target='_blank'>PIDM's TIPS Brochure</a>",
    "declaration.insurance.protectedByPIDM": "The benefit(s) payable under eligible policy are protected by PIDM up to limits. Please refer to <a className='a-link' href='https://www.pidm.gov.my/en/how-we-protect-you/tips/information-materials/brochures' target='_blank'>PIDM's TIPS Brochure</a>",
    "declaration.takaful.contact": "or contact Etiqa General Takaful Berhad or PIDM (visit <a className='a-link' href='https://www.pidm.gov.my/en' target='_blank'>www.pidm.gov.my</a>).",
    "declaration.insurance.contact": "or contact Etiqa General Insurance Berhad or PIDM (visit <a className='a-link' href='https://www.pidm.gov.my/en' target='_blank'>www.pidm.gov.my</a>).",
    "marketingConsent.title": "Marketing Consent",
    "marketingConsent.optional": "(Optional)",
    "marketingConsent.insurance.agree": "I expressly agree to receive marketing communications from Etiqa General Insurance or Maybank Group, Etiqa General Insurance agents or strategic partners, and other third parties (“other entities”, as Etiqa General Insurance deems fit about products and services that may be of interest of me.",
    "marketingConsent.takaful.agree": "I expressly agree to receive marketing communications from Etiqa General Takaful Berhad or Maybank Group, Etiqa General Takaful Berhad's agents or strategic partners, and other third parties (“other entities”), as Etiqa General Takaful Berhad deems fit about products and services that may be of interest of me.",
    "payment.title": "How would you like to proceed with payment?",
    "payment.VisaMastercard": "Visa/Mastercard",
    "payment.Amex": "Amex",
    "payment.EzPay": "Maybank EzPay",
    "payment.OnlineBankingM2u": "Online Banking Payment / Maybank2U"
    
  }
}
